import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DICTIONARIES } from "@/lib/i18n";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: DICTIONARIES.en,
});

const STORAGE_KEY = "era_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "id") return stored;
    return "en";
  });

  const setLang = (next) => {
    if (next !== "en" && next !== "id") return;
    setLangState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (_) {
      /* noop */
    }
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: DICTIONARIES[lang] || DICTIONARIES.en }),
    [lang],
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
